import leeCoreLexHabitFormationExperiments from 'bundles/epic/clients/leeCoreLexHabitFormation';

export function isUnifiedGoalSettingEnabled() {
  // Temporarily hardcoding this to true so we can end the UGS rollout experiment that was needed for the 2024 global holdout.
  // Logged a ticket to delete all the now-unused code to complete the cleanup: https://coursera.atlassian.net/browse/LRNRSCCSS-3616
  return true;
}

export function isDeadlineUxCopyChangeEnabled() {
  return leeCoreLexHabitFormationExperiments.get('deadlineUxCopyChangeEnabled');
}
